import ManageCollections from 'components/v2/collections/ManageCollections';
import { CompanyContext } from 'contexts/CompanyContextProvider';
import React from 'react';
import { Container } from 'styles/Styles.styled';

import { withGreyBackground } from '../WithGreyBackground';
import Welcome from 'pages/dashboard/Welcome';

const CompanyCollections: React.FunctionComponent = () => {
  const { companyId } = React.useContext(CompanyContext);

  return companyId ? (
    <Container>
      <ManageCollections companyId={companyId || ''} key={'collections'} />
    </Container>
  ) : (
    <Welcome />
  );
};

export default withGreyBackground(CompanyCollections);
